var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInrevLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 22,
    viewBox: "0 0 83 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5059 4.01261C28.5059 3.03375 29.2977 2.25623 30.2907 2.25623C31.2836 2.25623 32.0755 3.03549 32.0755 4.01261C32.0755 4.98973 31.2836 5.76898 30.2907 5.76898C29.2977 5.76898 28.5059 4.98973 28.5059 4.01261ZM28.7298 16.6284V6.98735H31.8532V16.6284H28.7298Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.553 16.6285V11.059C40.553 9.88061 39.9233 9.46231 38.9498 9.46231C37.9763 9.46231 37.3238 10.186 37.0433 10.6408V16.6285H33.9199V6.98743H37.0433V8.16588C37.6324 7.48725 38.7876 6.74792 40.4313 6.74792C42.6623 6.74792 43.6764 8.0253 43.6764 9.80251V16.6285H40.553Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2898 16.6283L51.0183 12.1176H48.9725V16.6283H45.7451V3.31311H52.26C55.2617 3.31311 56.9653 5.2691 56.9653 7.74398C56.9653 10.0592 55.5244 11.2967 54.2671 11.7358L57.0254 16.6266H53.2898V16.6283ZM51.9918 6.20801H48.9725V9.20185H51.9918C52.9056 9.20185 53.6761 8.62219 53.6761 7.70406C53.6761 6.78598 52.9056 6.20628 51.9918 6.20628V6.20801Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.005 6.74792C65.9062 6.74792 68.0154 8.84446 68.0154 12.1177V12.7773H61.0382C61.2202 13.6763 62.0735 14.4937 63.5338 14.4937C64.4068 14.4937 65.5126 14.0511 66.3946 13.4524L67.2462 15.5906C66.1513 16.3646 64.6502 16.868 63.1496 16.868C60.1265 16.868 57.7949 14.9311 57.7949 11.7984C57.7949 9.00413 59.945 6.74792 63.0084 6.74792H63.005ZM60.9961 10.7796H65.0331C64.952 10.101 64.4438 9.12215 63.005 9.12215C61.6452 9.12215 61.1176 10.0802 60.9961 10.7796Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4926 6.9873L73.7045 13.0947L75.9352 6.9873H79.242L75.3888 16.6283H72.0622L68.209 6.9873H71.4943",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.73 0C16.654 0 21.4617 4.73113 21.4617 10.5591C21.4617 16.3871 16.654 21.12 10.7318 21.12H0V10.5591C0 4.73113 4.80768 0 10.73 0Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7318 10.5609H0V21.1218H10.7318V10.5609Z",
    fill: "#111835"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.1201H10.6506L0 10.639V21.1201Z",
    fill: "#F2C232"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInrevLogo);
export default __webpack_public_path__ + "static/media/inrev-logo.e9b044099f52613cbdca91b18a5b5652.svg";
export { ForwardRef as ReactComponent };